import styled from 'styled-components';

export const ProgressVolumeBarWrapper = styled.div``;
export const RequestedQtyText = styled.span`
  font-family: Work Sans;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const ProgressVolumeBarContainer = styled.div`
  display: flex;
  width: 100%;
  box-shadow: ${({ theme }) => theme.commoms.boxShadow};

  & > div {
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-size: 14px;

    height: 22px;

    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }

    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    &.meltShop {
      background-color: ${({ theme }) => theme.colors.lightGray5};
    }

    &.rollingMill {
      background-color: ${({ theme }) => theme.colors.grayDark5};
    }

    &.rollingFinish {
      background-color: ${({ theme }) => theme.colors.blue4};
    }

    &.finish {
      background-color: ${({ theme }) => theme.colors.lightBlue4};
    }

    &.stockMill {
      background-color: ${({ theme }) => theme.colors.purple2};
    }

    &.transit {
      background-color: ${({ theme }) => theme.colors.purple3};
    }

    &.stockWarehouse {
      background-color: ${({ theme }) => theme.colors.red6};
    }

    &.pending {
      background-color: ${({ theme }) => theme.colors.lightGray5};
    }

    &.delivery {
      background-color: #8e291a;
    }

    &.shipment {
      background-color: ${({ theme }) => theme.colors.blueGerdau};
    }

    &.billed {
      background-color: ${({ theme }) => theme.colors.statusGreen};
    }

    &.cancelled {
      background-color: ${({ theme }) => theme.colors.red};
    }

    &.balance {
      background-color: ${({ theme }) => theme.colors.lightGray2};
      color: ${({ theme }) => theme.colors.grayDark4};
    }
  }
`;
